import { forwardRef, type HTMLAttributes } from 'react';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';
import cn from 'classnames';

import css from './styles.module.scss';

interface ArrowNavProps extends HTMLAttributes<HTMLDivElement> {
  arrowPosition: 'left' | 'right';
}

const ArrowNav = forwardRef<HTMLDivElement, ArrowNavProps>(
  ({ arrowPosition, ...props }, ref) => {
    return (
      <div {...props} ref={ref} className={cn(css.arrowBtn, props.className)}>
        <ChevronIcon
          className={cn(
            'text-white/40 w-[0.7825rem] h-[1.40625rem]',
            arrowPosition === 'right' && 'rotate-180 translate-x-[2px]',
            arrowPosition === 'left' && '-translate-x-[2px]',
          )}
        />
      </div>
    );
  },
);

export { ArrowNav };
